const Competitors = {
   'localhost': 4,
   'smartintel.io': 4,
   'mobica.smartintel.io': 6
}

module.exports = Competitors


// WEBPACK FOOTER //
// ./src/constants/competitors.js